import { render } from "./SavedViews.vue?vue&type=template&id=4d5eed2d&scoped=true"
import script from "./SavedViews.vue?vue&type=script&lang=js"
export * from "./SavedViews.vue?vue&type=script&lang=js"

import "./SavedViews.vue?vue&type=style&index=0&id=4d5eed2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5eed2d"]])

export default __exports__